import { render, staticRenderFns } from "./LightAnalysis.vue?vue&type=template&id=b35a8244"
import script from "./LightAnalysis.vue?vue&type=script&lang=js"
export * from "./LightAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports